export class ThreatDetectionFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SecurityAssignmentStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SecurityAssignmentStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ThreatDetectionFilters.attributeTypeMap;
    }
    constructor() {
    }
}
